import Colors from '@/constants/Colors';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledComicActivity = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media screen and (min-aspect-ratio: 3) {
    height: 90vh;
    width: initial;
  }
`;

export const StyledComicFullscreenBackground = createGlobalStyle`
  .activity-wrapper {
    --fullScreenBackground: ${Colors.background};
  }
`;
